import { PictureFilled } from '@ant-design/icons';

export default function EmptyImage() {
  return (
    <div className='flex h-full flex-col items-center justify-center'>
      <PictureFilled className='text-[40px] text-[#00000073]' />
    </div>
  );
}
